import { lightBlue } from '@material-ui/core/colors';
import styled from 'styled-components';

interface HelperTextTipProps {
  text: React.ReactNode;
  tip?: React.ReactNode;
  tipColor?: string;
}

/**
 * Create a helper text with a small tip.
 */
export const HelperTextTip = ({
  text,
  tip = null,
  tipColor = lightBlue[400],
}: HelperTextTipProps) => (
  <>
    {text} {tip && <HelperTip $color={tipColor}>{tip}</HelperTip>}
  </>
);
const HelperTip = styled.em<{ $color: string }>`
  color: ${props => props.$color || lightBlue[900]};
`;
